
export const FETCH_PRODUCT_REQUESTS_START = "FETCH_PRODUCT_REQUESTS_START";
export const FETCH_PRODUCT_REQUESTS_SUCCESS = "FETCH_PRODUCT_REQUESTS_SUCCESS";
export const FETCH_PRODUCT_REQUESTS_ERROR = "FETCH_PRODUCT_REQUESTS_ERROR";

export const UPDATE_PRODUCT_REQUEST_START = "UPDATE_PRODUCT_REQUEST_START";
export const UPDATE_PRODUCT_REQUEST_CLEAR = "UPDATE_PRODUCT_REQUEST_CLEAR";
export const UPDATE_PRODUCT_REQUEST_SUCCESS = "UPDATE_PRODUCT_REQUEST_SUCCESS";
export const UPDATE_PRODUCT_REQUEST_ERROR = "UPDATE_PRODUCT_REQUEST_ERROR";